export function handleError(e) {
  switch (e.response.status) {
    default:
      break;
  }
}
